import cloudModule from './cloud.module';

export default cloudModule.config($stateProvider =>
    $stateProvider
        .state({
            name: 'cloud',
            url: '/cloud',
            component: 'cloud',
            redirectTo: 'registration'
        })
        .state({
            parent: 'cloud',
            name: 'registration',
            url: '/registration?instanceGuid&origin',
            component: 'registration',
            protected: true
        })
        .state({
            parent: 'cloud',
            name: 'urlVerification',
            url: '/url-verification?instanceGuid&origin',
            component: 'urlVerification',
            protected: true
        })
        .state({
            parent: 'cloud',
            name: 'cloudOtherwise',
            url: '/*path',
            redirectTo: 'registration'
        })
);



// WEBPACK FOOTER //
// ./modules/cloud/cloud.states.js